import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.styl']
})
export class ModalComponent implements OnInit {
  @Input() showCloseButton = true;
  @Input() closeOnBackgroundClick = true;
  @Input() opened = false;
  @Output() openedChange: EventEmitter<boolean> = new EventEmitter();
  @Output() close = new EventEmitter();
  @Output() open = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }

  onCloseButtonClick() {
    this.closeModal();
  }

  onBackgroundClick() {
    if (this.closeOnBackgroundClick) {
      this.closeModal();
    }
  }

  closeModal() {
    this.openedChange.emit(this.opened = false);
    this.close.emit();
  }

  openModal() {
    this.openedChange.emit(this.opened = true);
    this.open.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/modal/modal.component.ts